import { useState } from "react";
import { Button } from "react-bootstrap";
import { I18n } from "@/i18n/I18n";
import { useGlobalStore } from "@/frontend/store/GlobalStore";
import { useProjectStore } from "@/frontend/store/ProjectStore";
import { useShallow } from "zustand/react/shallow";
import { RequirementSubjectType } from "@/backend/access/requirement/types";
import { CreateRequirementModal } from "../requirements/CreateRequirementModal";
import { AssignRequirementModal } from "./AssignRequirementModal";

interface ProjectRequirementActionsProps {
  projectId: string;
}

export function ProjectRequirementActions({ projectId }: ProjectRequirementActionsProps) {
  const project = useProjectStore(useShallow(state => state.projects.find(p => p.id === projectId)));
  const user = useGlobalStore(state => state.userClass);
  const [showAssignModal, setShowAssignModal] = useState(false);

  if (!project || user?.getOrgId() !== project.propelOrgId) {
    return null;
  }

  return (
    <>
      <CreateRequirementModal
        subjectId={projectId}
        subjectType={RequirementSubjectType.PROJECT}
      />
      <Button
        className="btn btn-sm btn-secondary bg-primary border-0"
        onClick={() => setShowAssignModal(true)}
        aria-label={I18n.get('assignRequirementFromOrganization')}
      >
        {I18n.get('assignRequirementFromOrganization')}
      </Button>
      {showAssignModal && (
        <AssignRequirementModal
          onHide={() => setShowAssignModal(false)}
          project={project}
        />
      )}
    </>
  );
}
